module.exports = __webpack_public_path__ + "img/challenger.785484c4.svg";